<script setup>
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import ImportUploadFile from "../components/ImportUploadFile.vue"
import { ref } from "vue"


const isLowerThanMobile = ref(KNOLIA.updateIsLowerThanMobile())
const isMobile = ref(KNOLIA.updateIsMobile())

async function Import(type) {
  const fileInput = document.getElementById(type)
  const file = document.getElementById(type).files[0]

  if (!file) {
    fileInput.click()
    return
  }

  let formData = new FormData()

  formData.append("file", file)
  formData.append("type", type)

  if (document.getElementById(`create-${type}-children`)?.checked)
    formData.append("children", 1)
  else
    formData.append("children", 0)

  const response = await KNOLIA.CallBackEnd("post", "import", formData);
  if (response.data.error) {
    Gems.Telegram(response.data.message, "tele-not-allowed")
    if (response.data.excel)
      Gems.ExportExcel(response.data.data)

    return
  }
  Gems.Telegram(response.data.message, "tele-success")

  document.getElementById(type).value = null
}

async function Export(type, table = null) {
  const res = await KNOLIA.CallBackEnd("post", "export", {
    type,
    table,
  })
  Gems.ExportExcel(res.data)
}

function ShowExcelInstructions(text, id) {
  const divExcelInstructions = document.getElementById(id)

  if (divExcelInstructions.children.length > 1) {
    window.CloseExcelInstructions(id)
  } else {
    const div = document.createElement("div")
    divExcelInstructions.appendChild(div)

    div.innerHTML += `<i class='bi bi-x-lg close-import' onclick='CloseExcelInstructions(${id})'></i>`;
    div.innerHTML += '<li>Apenas importe ficheiros que foram exportados deste interface.</li>'
    div.innerHTML += '<li>Não apague colunas do EXCEL exportado.</li>'
    div.innerHTML += '<li>Os registos serão processados pela ordem em que aparecem no ficheiro.</li>'
    div.innerHTML += "<li>Dado nulo (vazio) em campos binários [ATIVO/INATIVO] será interpretado como '0' (zero).</li>"
    div.innerHTML += "<li>Os dados NÃO deverão conter o caracter ';' (ponto e vírgula).</li>"
    div.innerHTML += text;
    div.innerHTML += '<li>Grave o ficheiro com o seguinte formato:</li>'
    div.innerHTML += "<div class='excel-img'>"
    div.setAttribute("class", "div-import-help")
  }
}

window.CloseExcelInstructions = (id) => {
  document.getElementById(id).removeChild(document.getElementById(id).lastElementChild)
}

window.addEventListener('resize', () => {
  isMobile.value = KNOLIA.updateIsMobile()
  isLowerThanMobile.value = KNOLIA.updateIsLowerThanMobile()
})

</script>
<template>
  <div class="page-container">

    <div class="container-info-circle">
      <div class="info-circle field-unique"></div>
      <p class="info-text">
        Campos de dados únicos
      </p>
    </div>


    <div class="container-info-circle">
      <div class="info-circle field-not-modify"></div>
      <p class="info-text">
        Em nenhuma circunstância modifique a coluna 'Key' [coluna A]
      </p>
    </div>

    <div class="group">
      <div id="1" class="div-excel-instructions">
        <div class="icon-container">
          <i class="fas fa-info-circle icon" @click="ShowExcelInstructions(`<br/>
            <li>Novo registo:</li>
              <ul>
                <li>[coluna A] precisa de estar vazia.</li>
                <li>O valor da [coluna B] não existe na Base de Dados.</li>
              </ul>
              <li>Atualização [colunas B, C, D e E]:</li>
              <ul>
                <li>[coluna A]  vazia e valor da [coluna B] existe na Base de Dados > Atualiza C, D e E.</li>
                <li>[coluna A]  não vazia > Atualiza B, C, D e E.</li>
              </ul>
            <br>`, 1)
            "></i>
          <span>Regras para importação</span>
        </div>
      </div>

      <button @click="Export(1, 'skills')" class="button ddl-alt-padding col-12 col-sm-8" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}">
        EXPORTAR COMPETÊNCIAS
      </button>
      <div class="row">
        <div class="col-12 col-sm-8 p-0">
          <table class="ex-table w-100">
            <thead>
              <tr>
                <th class="field-not-modify">A. Key</th>
                <th class="field-unique"><span class="line-clamp line-clamp-2">B. Código da competência</span></th>
                <th><span class="line-clamp line-clamp-2">C. Descritor</span></th>
                <th><span class="line-clamp line-clamp-2">D. Inativo</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ex.: 1</td>
                <td>Ex.: A5003</td>
                <td><span class="line-clamp line-clamp-2">Ex.: Coordenação</span></td>
                <td>Ex.: 0</td>
              </tr>
              <tr> 
                <td><span class="line-clamp line-clamp-2">(campo numérico)</span></td>
                <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
                <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
                <td><span class="line-clamp line-clamp-2">(campo binário - 0 ou 1)</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="div-children col-12 col-sm-auto align-content-center div-op-skills-config">
          <div>
            <input type="radio" name="skills-children" class="cursor-pointer" id="create-skills-children">
            <label>Criar comp. operativas automaticamente</label>
          </div>

          <div>
            <input type="radio" name="skills-children" class="cursor-pointer" checked>
            <label>Não criar competências operativas</label>
          </div>
        </div>
      </div>
      <div class="upload-file parent-upload-file">
        <ImportUploadFile :table-name="'skills'" @import="Import($event)" :is-mobile="isMobile" :is-lower-than-mobile="isLowerThanMobile" />
      </div>

      <button @click="Export(2, 'skillsOp')" class="button ddl-alt-padding col-12" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}">
        EXPORTAR COMPETÊNCIAS OPERATIVAS
      </button>
      <table class="ex-table w-100">
        <thead>
          <tr>
            <th class="field-not-modify">A. Key</th>
            <th class="field-unique"><span class="line-clamp line-clamp-2">B. Código da competência operativa</span></th>
            <th><span class="line-clamp line-clamp-2">C. Código da competência</span></th>
            <th><span class="line-clamp line-clamp-2">D. Descritor</span></th>
            <th>E. Inativo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ex.: 1</td>
            <td>Ex.: T1003</td>
            <td>Ex.: 15003</td>
            <td><span class="line-clamp line-clamp-2">Ex.: Coordenação</span></td>
            <td>Ex.: 0</td>
          </tr>
          <tr> 
            <td><span class="line-clamp line-clamp-2">(campo numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo binário - 0 ou 1)</span></td>
          </tr>
        </tbody>
      </table>
      <div class="upload-file">
        <ImportUploadFile :table-name="'skills-op'" @import="Import($event)" :is-mobile="isMobile" :is-lower-than-mobile="isLowerThanMobile" />
      </div>

      <button @click="Export(3, 'activities')" class="button ddl-alt-padding col-12 col-sm-8" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}">
        EXPORTAR ATIVIDADES
      </button>

      <div class="row">
        <div class="col-12 col-sm-8 p-0">
          <table class="ex-table w-100">
            <thead>
              <tr>
                <th class="field-not-modify">A. Key</th>
                <th class="field-unique"><span class="line-clamp line-clamp-2">B. Código da atividade</span></th>
                <th><span class="line-clamp line-clamp-2">C. Descritor</span></th>
                <th><span class="line-clamp line-clamp-2">D. Inativo</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ex.: 1</td>
                <td>Ex.: C4000</td>
                <td><span class="line-clamp line-clamp-2">Ex.: Coordenação</span></td>
                <td>Ex.: 0</td>
              </tr>
              <tr> 
                <td><span class="line-clamp line-clamp-2">(campo numérico)</span></td>
                <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
                <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
                <td><span class="line-clamp line-clamp-2">(campo binário - 0 ou 1)</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="div-children col-12 col-sm-auto align-content-center div-tasks-config">
          <div>
            <input type="radio" name="activities-children" class="cursor-pointer" id="create-activities-children">
            <label>Criar tarefas automaticamente</label>
          </div>

          <div>
            <input type="radio" name="activities-children" class="cursor-pointer" checked>
            <label>Não criar tarefas</label>
          </div>
        </div>
      </div>

      <div class="upload-file parent-upload-file">
        <ImportUploadFile :table-name="'activities'" @import="Import($event)" :is-mobile="isMobile" :is-lower-than-mobile="isLowerThanMobile" />
      </div>

      <button @click="Export(4, 'tasks')" class="button ddl-alt-padding col-12" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}">
        EXPORTAR TAREFAS
      </button>
      <table class="ex-table w-100">
        <thead>
          <tr>
            <th class="field-not-modify">A. Key</th>
            <th class="field-unique"><span class="line-clamp line-clamp-2">B. Código da tarefa</span></th>
            <th><span class="line-clamp line-clamp-2">C. Código da atividade</span></th>
            <th><span class="line-clamp line-clamp-2">D. Descritor</span></th>
            <th><span class="line-clamp line-clamp-2">E. Inativo</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ex.: 1</td>
            <td>Ex.: T1400</td>
            <td>Ex.: 14000</td>
            <td><span class="line-clamp line-clamp-2">Ex.: Coordenação</span></td>
            <td>Ex.: 0</td>
          </tr>
          <tr>
            <td><span class="line-clamp line-clamp-2">(campo numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo alfa-numérico)</span></td>
            <td><span class="line-clamp line-clamp-2">(campo binário - 0 ou 1)</span></td>
          </tr>
        </tbody>
      </table>
      <div class="upload-file">
        <ImportUploadFile :table-name="'tasks'" @import="Import($event)" :is-mobile="isMobile" :is-lower-than-mobile="isLowerThanMobile"/>
      </div>
    </div>
  </div>
</template>

<style>
.blink-import {
  animation: blink-import 1s step-start infinite;
}

@keyframes blink-import {
  50% {
    background-color: var(--default-font-color);
    color: #2361C2;
  }
}

.container-info-circle {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.info-text {
  font-size: .9em;
  margin: 0px 5px;
  font-weight: 300;
}

.field-not-modify {
  background-color: #ff0050;
  color: white;
}

.field-unique {
  background-color: #336fc3;
  color: white;
}

.div-import-help {
  font-size: 0.8em;
  background-color: #404d6dcc;
  backdrop-filter: blur(10px);
  position: absolute;
  top: 0px;
  left: 30px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  max-height: 650px;
  min-height: 20px;
  max-width: 610px;
  min-width: 290px;
  z-index: 10;
}

.div-import-help li {
  margin-left: 15px;
}

.close-import {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 1.3em !important;
  cursor: pointer;
  border: none !important;
  width: 10px !important;
  height: 10px !important;
  background-color: transparent;
}

.close-import:hover {
  color: var(--default-app-hover-color) !important;
  position: absolute;
  background-color: transparent !important;
}

.excel-img {
  display: block;
  height: 300px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("../images/excel.png");
  background-size: contain;
}

</style>

<style scoped>
.upload-file {
  display: flex;
  margin-bottom: 5px;
  margin-top: 5px;
  align-items: center;
}

.ex-table {
  height: 100px;
  text-align: center;
  word-wrap: break-word;
  border: 1px solid var(--default-overlay-color);
  border-collapse: separate;
  border-left: 0;
  border-radius: 25px !important;
  border-spacing: 0px;
  background-color: var(--default-app-alt-line-color);
}

.ex-table thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  border-collapse: separate;
}

.ex-table thead tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

.ex-table th,
.ex-table tbody td {
  padding: 5px 4px 6px 4px;
  text-align: left;
  vertical-align: top;
  border-left: 1px solid;
}

.ex-table tbody td {
  border-top: 1px solid;
}

.ex-table thead:first-child tr:first-child th:first-child,
.ex-table tbody:first-child tr:first-child td:first-child {
  border-radius: 25px 0 0 0;
}

table.ex-table thead:last-child tr:last-child th:first-child,
table.ex-table tbody:last-child tr:last-child td:first-child {
  border-radius: 0 0 0 25px;
}

.ex-table td,
.ex-table th {
  padding: 3px 2px;
}

.ex-table thead th,
.ex-table tbody td {
  text-align: center;
  border-color: var(--default-overlay-color);
  vertical-align: middle;
}

.ex-table thead th {
  font-weight: bold;
}

.div-children div {
  display: flex;
  gap: 5px;
}

.button {
  /* width: 100%; */
  margin-bottom: 2px;
  line-height: 1lh;
}

.button:not(:first-of-type) {
  margin-top: 30px;
}

.button:first-of-type {
  margin-top: 10px;
}

.group {
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: var(--default-overlay-color);
}

.div-excel-instructions {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.icon-container {
  display: flex;
  align-items: center;
}

.icon-container>span {
  font-weight: bold;
}

.icon {
  font-size: 1.3em;
  cursor: pointer;
  margin-right: 5px;
}

.row {
  padding: 0px 10px;
}

.col-sm-8 {
  width: 75% !important;
}

.col-sm-auto {
  width: 25%;
}

.div-op-skills-config div{
  margin-left: 12%
}

.div-tasks-config div{
  margin-left: 20%
}

@media screen and (max-width: 600px) {
  .ex-table thead th,
  .ex-table tbody td {
    font-size: 1em;
  }
}
</style>
